import {
  AudioRecordingModelData,
  AudioRecordingUploadStatus,
} from "@/store/audio-recordings/types";
import { BaseAudioRecordingAppEventOperation } from "./BaseAudioRecordingAppEventOperation";
import { AudioRecordingAppEventOperationKind } from "@/store/sync/operations/types";

export class MarkErrorUploadingAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind(): AudioRecordingAppEventOperationKind {
    return "MARK_ERROR_UPLOADING_AUDIO_RECORDING";
  }

  protected getModelDataUpdates(
    _existingData: AudioRecordingModelData
  ): Partial<AudioRecordingModelData> {
    return {
      upload_status: AudioRecordingUploadStatus.ERROR,
    };
  }
}
